import React, { useState } from 'react';
import { customersAPI } from '../services/api';

function AddCustomerModal({ onClose, onCustomerAdded }) {
  const [formData, setFormData] = useState({
    identity_id: '',
    name: '',
    phone: '',
    email: '',
    address: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // Clear error when user starts typing
  };

  const validateForm = () => {
    if (!formData.identity_id.trim()) {
      setError('תעודת זהות חובה');
      return false;
    }
    if (!/^\d+$/.test(formData.identity_id.trim())) {
      setError('תעודת זהות חייבת להכיל רק ספרות');
      return false;
    }
    if (formData.identity_id.trim().length !== 9) {
      setError('תעודת זהות חייבת להכיל בדיוק 9 ספרות');
      return false;
    }
    if (!formData.name.trim()) {
      setError('שם חובה');
      return false;
    }
    if (formData.name.trim().length < 2) {
      setError('שם חייב להכיל לפחות 2 תווים');
      return false;
    }
    // Email validation if provided
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('מייל לא תקין');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const customerData = {
        identity_id: formData.identity_id.trim(),
        name: formData.name.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim() || null,
        address: formData.address.trim()
      };

      await customersAPI.create(customerData);
      onCustomerAdded(customerData.identity_id);
      onClose();
    } catch (err) {
      console.error('Error creating customer:', err);
      if (err.response?.status === 400) {
        setError('לקוח עם תעודת זהות זו כבר קיים');
      } else {
        setError('שגיאה בהוספת לקוח. אנא נסו שוב.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>הוספת לקוח חדש</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>תעודת זהות *</label>
            <input
              type="text"
              name="identity_id"
              value={formData.identity_id}
              onChange={handleChange}
              placeholder="הכנס תעודת זהות"
              disabled={loading}
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label>שם *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="הכנס שם"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>טלפון (אופציונלי)</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="הכנס טלפון"
              disabled={loading}
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label>מייל (אופציונלי)</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="הכנס מייל"
              disabled={loading}
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label>כתובת (אופציונלי)</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="הכנס כתובת"
              disabled={loading}
              rows="3"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="modal-footer">
            <button 
              type="button" 
              onClick={onClose}
              disabled={loading}
              className="btn-cancel"
            >
              ביטול
            </button>
            <button 
              type="submit"
              disabled={loading}
              className="btn-submit"
            >
              {loading ? 'טוען...' : 'הוסף לקוח'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCustomerModal;
